import {
  getAllResidentialZones,
  getAllPatrimonialZones,
  getAllOthersZones,
  getAllCostaZones,
  getAllRusticAndSingularZones,
} from "../api/zones.api";

export const patrimonioGroups = [
  {
    title: "General",
    fields: [
      { name: "airConditioning", label: "Aire Acondicionado" },
      { name: "freeHeight", label: "Altura Libre > 2,5 m" },
      { name: "centralHeating", label: "Calefacción Central" },
      { name: "individualHeating", label: "Calefacción Individual" },
      { name: "lift", label: "Ascensor" },
      { name: "liftTruck", label: "Montacargas" },
      { name: "reformed", label: "Reformado" },
      { name: "toReform", label: "A reformar" },
      { name: "concierge", label: "Servicio de Portería" },
      { name: "garage", label: "Garaje" },
      { name: "qualityBathrooms", label: "Baños" },
      { name: "terrace", label: "Terraza" },
      { name: "storage", label: "Trastero" },
      { name: "homeAutomation", label: "Domótica" },
    ],
  },
  {
    title: "Oficinas",
    fields: [
      {
        name: "exclusiveOfficeBuilding",
        label: "Edificio Exclusivo de Oficinas",
      },
      { name: "mixedBuilding", label: "Edificio Mixto" },
      { name: "classicBuilding", label: "Edificio Clásico" },
      { name: "coworking", label: "Coworking" },
      { name: "implanted", label: "Implantada" },
      { name: "furnished", label: "Amueblada" },
      { name: "falseCeiling", label: "Falso Techo" },
      { name: "raisedFloor", label: "Suelo Técnico" },
      { name: "accessControl", label: "Control de Accesos" },
      { name: "fullHoursSecurity", label: "Seguridad 24h" },
    ],
  },
  {
    title: "Locales",
    fields: [
      { name: "separateEntrance", label: "Entrada Independiente" },
      { name: "smokeOutlet", label: "Salida de Humos" },
      { name: "accessiblePMR", label: "Accesible PMR" },
    ],
  },
];

export const residentialGroups = [
  {
    title: "General",
    fields: [
      { name: "classicBuilding", label: "Edificio Clásico" },
      { name: "terrace", label: "Terraza" },
      { name: "storage", label: "Trastero" },
      { name: "fireplace", label: "Chimena" },
      // AQUI VAN PISCINA INTERIOR Y EXTERIOR QUE OCURRE CON ESTO? SOLAMENTE EXISTE PISCINA A NIVEL GENERAL
      { name: "swimmingPool", label: "Piscina" },
      // ------------------------------------------------
      { name: "reformed", label: "Reformado" },
      { name: "toReform", label: "A reformar" },
      { name: "furnished", label: "Amueblada" },
      { name: "lift", label: "Ascensor" },
      { name: "liftTruck", label: "Montacargas" },
      { name: "airConditioning", label: "Aire Acondicionado" },
      { name: "centralHeating", label: "Calefacción Central" },
      { name: "individualHeating", label: "Calefacción Individual" },
      { name: "subfloorHeating", label: "Suelo Radiante" },
      { name: "indoorAlarm", label: "Alarma Interior" },
      { name: "outdoorAlarm", label: "Alarma Perimetral" },
      { name: "fullHoursSecurity", label: "Seguridad 24h" },
      { name: "concierge", label: "Servicio de Portería" },
      { name: "homeAutomation", label: "Domótica" },
      { name: "gym", label: "Gimnasio" },
      { name: "padelCourt", label: "Pista de Pádel" },
      { name: "tennisCourt", label: "Pista de Tenis" },
      { name: "strongBox", label: "Caja Fuerte" },
    ],
  },
];

export const costaGroups = [
  {
    title: "General",
    fields: [
      // AQUI VAN PISCINA INTERIOR Y EXTERIOR QUE OCURRE CON ESTO? SOLAMENTE EXISTE PISCINA A NIVEL GENERAL
      {
        name: "swimmingPool",
        label: "Piscina (Desmarcar y pasar a Interior o Exterior)",
      },
      // SE AÑADE UN CHECK PARA INDICAR EN EL CASO DE EXTERIOR SI ESTA CUBIERTA O NO?
      // ------------------------------------------------
    ],
  },

  {
    title: "Estilo",
    fields: [
      {
        name: "modernStyle",
        label: "Moderno",
      },
      { name: "classicStyle", label: "Clásico" },
      { name: "andaluzStyle", label: "Andaluz" },
    ],
  },
  {
    title: "Vistas",
    fields: [
      {
        name: "seaViews",
        label: "Vista al mar",
      },
      { name: "panoramicView", label: "Panorámica" },
      { name: "golfCourseView", label: "Campo de Golf" },
      { name: "mountainView", label: "Montaña" },
    ],
  },
  {
    title: "Exterior",
    fields: [
      {
        name: "outdoorPoolCheck",
        label: "Piscina Exterior",
      },
      { name: "outdoorPoolClimatized", label: "Piscina Climatizada" },
      {
        name: "privateGarden",
        label: "Jardín Privado",
      },
      { name: "solarium", label: "Solárium" },
      { name: "outdoorKitchen", label: "Cocina Exterior" },
      { name: "carPort", label: "Carport" },
      { name: "lounge", label: "Lounge" },
      { name: "firePlace", label: "Fireplace" },
    ],
  },
  {
    title: "Interior",
    fields: [
      { name: "indoorPoolCheck", label: "Piscina Interior" },
      { name: "showKitchen", label: "Show Kitchen" },
      { name: "dirtyKitchen", label: "Dirty Kitchen" },
      { name: "lift", label: "Ascensor" },
      { name: "subfloorHeating", label: "Suelo Radiante" },
      { name: "airConditioning", label: "Aire Acondicionado" },
      { name: "fireplace", label: "Chimenaa" },
      { name: "homeAutomation", label: "Domótica" },
      { name: "gym", label: "Gimnasio" },
      { name: "spa", label: "Spa" },
      { name: "movieTheater", label: "Sala de Cine" },
      { name: "wineCellar", label: "Bodega" },
      { name: "laundry", label: "Lavandería" },
    ],
  },
  {
    title: "Otros comunes",
    fields: [
      { name: "brandedDesign", label: "Branded Design" },
      { name: "conciergeService", label: "Servicio de Consiergerie" },
    ],
  },
  {
    title: "Seguridad",
    fields: [
      { name: "gatedCommunity", label: "Urbanización Cerrada" },
      { name: "fullHoursSecurity", label: "Seguridad 24h" },
      { name: "accessControl", label: "Control de Accesos" },
      { name: "indoorAlarm", label: "Alarma Interior" },
      { name: "outdoorAlarm", label: "Alarma Perimetral" },
      { name: "panicRoom", label: "Panic Room" },
    ],
  },
  {
    title: "Estado del Inmueble",
    fields: [
      { name: "newConstruction", label: "Obra Nueva" },
      { name: "reformed", label: "Reformado" },
      { name: "goodConservation", label: "Buena Conservación" },
      { name: "toReform", label: "A Reformar" },
    ],
  },
];

export const singularesYRusticoGroups = [
  {
    title: "Tipo de Finca",
    fields: [
      { name: "agricultural", label: "Agrícola" },
      { name: "hunting", label: "Cinegética" },
      { name: "forestry", label: "Forestal" },
      { name: "livestock", label: "Ganadera" },
      { name: "recess", label: "Recreo" },
      { name: "rusticOther", label: "Otros" },
    ],
  },
  {
    title: "Finca",
    fields: [
      { name: "warehouses", label: "Naves" },
      { name: "secondaryHousing", label: "Viviendas Secundarias" },
      { name: "equestrianFacilities", label: "Instalaciones Hípicas" },
      { name: "fenced", label: "Vallada" },
      { name: "electricSupply", label: "Suministro Eléctrico" },
      { name: "pond", label: "Charca" },
      { name: "reservoir", label: "Pantano" },
      { name: "swimmingPool", label: "Piscina" },
      { name: "well", label: "Pozo" },
    ],
  },
  {
    title: "Vivienda",
    fields: [
      { name: "reformed", label: "Reformado" },
      { name: "toReform", label: "A Reformar" },
      { name: "airConditioning", label: "Aire Acondicionado" },
      { name: "homeAutomation", label: "Domótica" },
      { name: "centralHeating", label: "Calefacción Central" },
      { name: "individualHeating", label: "Calefacción individual" },
      { name: "porch", label: "Porche" },
      { name: "padelCourt", label: "Pista de pádel" },
      { name: "tennisCourt", label: "Pista de tenis" },
    ],
  },
];

export const allOtherQualities = [
  ...patrimonioGroups.flatMap((g) => g.fields),
  ...costaGroups.flatMap((g) => g.fields),
  ...singularesYRusticoGroups.flatMap((g) => g.fields),
  ...residentialGroups.flatMap((g) => g.fields),
  // Añadimos campos extra que no estén en los grupos anteriores si los hubiera
  // { name: "centralVacuum", label: "Aspiración Centralizada" },
];

export const adStatusOptions = [
  { name: "En preparación" },
  { name: "Activo" },
  { name: "Inactivo" },
];

export const gvOperationCloseOptions = [
  { name: "Alquilado" },
  { name: "Vendido" },
];

export const operationTypeOptions = [{ name: "Alquiler" }, { name: "Venta" }];

export const departmentOptions = [
  { name: "Patrimonio" },
  { name: "Residencial" },
  // { name: "Otros" },
  { name: "Costa" },
  { name: "Campos Rústicos & Activos Singulares" },
];

export const buildingTypeOptions = [
  { name: "Casa" },
  { name: "Piso" },
  { name: "Parcela" },
  { name: "Ático" },
  { name: "Oficina" },
  { name: "Edificio" },
  { name: "Local" },
  { name: "Campo Rústico" },
  { name: "Activos singulares" },
  { name: "Costa" },
];

export const ALL_BUILDING_TYPES = [
  { name: "Casa" },
  { name: "Piso" },
  { name: "Ático" },
  { name: "Bajo" },
  { name: "Parcela" },
  { name: "Oficina" },
  { name: "Edificio" },
  { name: "Local" },
  { name: "Nave" },
  { name: "Suelo" },
  { name: "Finca" },
  { name: "Casa de Campo" },
  { name: "Activo Singular" },
];

export const saleOrderOptions = [
  { name: "Defecto" },
  { name: "Descendente" },
  { name: "Ascendente" },
];

export const RentOrderOptions = [
  { name: "Defecto" },
  { name: "Descendente" },
  { name: "Ascendente" },
];

export const departmentFields = {
  Patrimonio: [
    { label: "Puestos de trabajo", name: "jobPositions", type: "number" },
    { label: "Plazas de garaje", name: "parking", type: "number" },
    { label: "Baños", name: "bathrooms", type: "number" },
    { label: "Metro", name: "subway", type: "text" },
    { label: "Bus", name: "bus", type: "text" },
  ],
  "Campos Rústicos & Activos Singulares": [
    { label: "Dormitorios", name: "bedrooms", type: "number" },
    { label: "Baños", name: "bathrooms", type: "number" },
    { label: "Piscina", name: "pool", type: "number" },
    { label: "Piscina Interior", name: "indoorPool", type: "number" },
    { label: "Piscina Exterior", name: "outdoorPool", type: "number" },
  ],
  Residencial: [
    { label: "Dormitorios", name: "bedrooms", type: "number" },
    { label: "Baños", name: "bathrooms", type: "number" },
    { label: "Plaza Garaje", name: "parking", type: "number" },
    { label: "Piscina Interior", name: "indoorPool", type: "number" },
    { label: "Piscina Exterior", name: "outdoorPool", type: "number" },
  ],
  Costa: [
    { label: "Dormitorios", name: "bedrooms", type: "number" },
    { label: "Baños", name: "bathrooms", type: "number" },
    { label: "Plazas de garaje", name: "parking", type: "number" },
    { label: "Piscina Interior", name: "indoorPool", type: "number" },
    { label: "Piscina Exterior", name: "outdoorPool", type: "number" },
  ],
};

const qualityNames = [...new Set(allOtherQualities.map((q) => q.name))];

export const FIELDS_TO_RESET = [
  // Información básica
  "zone",
  "floor",
  "disponibility",
  "m2Terrace",
  "m2StorageSpace",
  "monthlyRent",
  "expenses",
  "expensesIncluded",
  "buildingYear",
  // Gastos
  "expensesValue",
  "ibiValue",
  "trashFeeValue",
  // Calidades dinámicas (las de departmentFields)
  "jobPositions",
  "parking",
  "bathrooms",
  "subway",
  "bus",
  "bedrooms",
  "pool",
  "storageRoom",
  // Descripción
  "web",
  "emailPDF",
  "distribution",
  // Rentabilidad
  "profitability",
  "profitabilityValue",
  "outdoorPoolClimatized",
  ...qualityNames,
];

export const BOOLEAN_FIELDS = [
  "profitability",
  "reformed",
  "toReform",
  "expensesShowOnWeb",
  "ibiShowOnWeb",
  "trashFeeShowOnWeb",
  "featuredOnMain",
  "featuredDrawings",
  "saleRepercussionM2ShowOnWeb",
  "rentRepercussionM2ShowOnWeb",
  "outdoorPoolClimatized",
  ...qualityNames,
];

export const ARRAY_FIELDS = [
  "zone",
  "adType",
  "realStatePortals",
  "adBuildingType",
];

export const DEPT_VALID_TYPES = {
  Patrimonio: ["Oficina", "Edificio", "Local", "Nave", "Suelo"],
  Residencial: ["Casa", "Piso", "Parcela", "Ático"],
  Costa: ["Casa", "Piso", "Parcela", "Ático", "Bajo"],
  "Campos Rústicos & Activos Singulares": [
    "Finca",
    "Casa de Campo",
    "Activo Singular",
  ],
};

export const residentialZones = getAllResidentialZones();
export const patrimonialZones = getAllPatrimonialZones();
export const othersZones = getAllOthersZones();
export const costaZones = getAllCostaZones();
export const rusticAndSingularZones = getAllRusticAndSingularZones();
